var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.379 1.207a3 3 0 0 1 4.242 0l1.172 1.172a3 3 0 0 1 0 4.242L5.414 18H0v-5.414L11.379 1.207Zm2.828 1.414a1 1 0 0 0-1.414 0l-.879.879L14.5 6.086l.879-.879a1 1 0 0 0 0-1.414L14.207 2.62ZM13.086 7.5 10.5 4.914l-8.5 8.5V16h2.586l8.5-8.5Z",
  clipRule: "evenodd"
})));
export default SvgIconPencil;